import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectStaticText } from '../StaticText/connect'
import Link from '../Link/index'
import { URL_ACCOUNT_CREATION } from '../../services/url/constants'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'

function AlertBarFreeTrialExpired (props) {
  const { staticText } = props

  return (
    <div className="alert-bar-free-trial-expired">
      <span>
        {/* <Link tag is awkwardly formatted because we need to keep
        the space between the two static text variables */}
        {staticText.getIn(['data', 'body'])} <Link
          to={URL_ACCOUNT_CREATION}
          className=""
        >
          {staticText.getIn(['data', 'button'])}
        </Link>
        <IconV2
          className="alert-bar-free-trial-expired__arrow-right"
          type={ICON_TYPES.CHEVRON_RIGHT}
        />
      </span>
    </div>
  )
}

AlertBarFreeTrialExpired.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'alertBarFreeTrialExpired' }),
)(AlertBarFreeTrialExpired)
